export const portal_url = "https://portal.gps.id/backend";
export const base_url = "https://seen.gps.id/backend";
export const api_url = "https://register.gps.id";
export const mobile_url = "https://mobile.gps.id";
export const api_key =
  "!E7ov0tNucevd&~=+Ez:fw5X2#Q;Bv#Ngz$9eZHe=[tBs^Zkc2~_PuPp~U>}CRZ";
